import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import ErrorBanner from '../../common/ErrorBanner';
import { getVoiceIvrFlows } from '../../../api/backendApi';

const columns = [
  { field: 'name', headerName: 'Flow Name', flex: 1, minWidth: 200 },
  {
    field: 'digitsMap',
    headerName: 'Digits Map',
    flex: 1,
    minWidth: 240,
    renderCell: (params) => {
      try {
        const json = params.value || {};
        const short = JSON.stringify(json).slice(0, 80);
        return (
          <Tooltip title={<pre style={{ margin: 0 }}>{JSON.stringify(json, null, 2)}</pre>} arrow>
            <span>{short}{JSON.stringify(json).length > 80 ? '…' : ''}</span>
          </Tooltip>
        );
      } catch {
        return <span />;
      }
    }
  },
  { field: 'version', headerName: 'Version', width: 120 },
  { field: 'updatedAt', headerName: 'Updated At', width: 200 },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 180,
    sortable: false,
    filterable: false,
    renderCell: () => {
      const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
      const href = projectId ? `https://console.firebase.google.com/project/${projectId}/firestore/data` : 'https://console.firebase.google.com/';
      return (
        <Button component="a" href={href} target="_blank" rel="noopener" size="small">View in Firestore</Button>
      );
    }
  }
];

const IvrFlowsTab = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setError(null);
      const data = await getVoiceIvrFlows();
      const shaped = (Array.isArray(data) ? data : []).map((x, idx) => ({ id: x.id || idx, ...x }));
      setRows(shaped);
    } catch (e) {
      setError(e?.message || 'Failed to load IVR flows');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Box>
      <ErrorBanner message={error} />
      <div style={{ height: 520, width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          disableRowSelectionOnClick
          density="compact"
          pageSizeOptions={[10, 25, 50]}
          initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        />
      </div>
    </Box>
  );
};

export default IvrFlowsTab;
